export default __webpack_public_path__ + "static/media/Serpent's Scale.fd68d67e.jpg";